import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { JwtHelperService } from '@auth0/angular-jwt';
import { EncryptDecryptService } from './services/encrypt-decrypt.service';

const jwtHelper = new JwtHelperService();

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  constructor(private http: HttpClient, private encdec: EncryptDecryptService) { }

  result = false;

  public isAuthenticated(): boolean {
    const token = localStorage.getItem('currentUser');
    
    if (token) {
      this.result = true;
    }
    return this.result;
  }
}
